module.exports = __webpack_public_path__ + "img/value-props-brand-3.52af01c8.jpg";